<div class="form-group" [ngClass]="{'has-error': !!errors }">
  <label class="control-label" [htmlFor]="controlName">
    {{ schemaTranslations?.getFieldTranslation(controlName) }}
    @if (properties | propertyIsFieldRequired:controlName) {
      <span class="required">*</span>
    }
    @if (properties | showPropertyArrayHint: controlName) {
      <app-hint
          [tooltipText]="(properties | propertyArrayHintText: controlName) | translate:(properties | propertyGetFields:controlName)"/>
    }
  </label>
  @if (formArrayControlsChanged$ | async) {
    @for (control of formArray.controls; track control; let i = $index) {
      <div
          [ngClass]="{ 'input--filled': !!control.value }">
        <div class="input-group">
          <input [type]="(properties | propertyHasNumericValues:controlName) ? 'number' : 'text'"
                 [formControl]="$any(control)"
                 class="form-control"
                 [id]="controlName + '_' + i">
          <span (click)="removeFormControlAtIndex(i)" class="input-group-addon">
              <a class="btn-circle"><i class="icon icon-times"></i></a>
            </span>
        </div>
      </div>
    }
  }
  <span (click)="addFormControl()">
      <a class="btn-circle"><i class="icon icon-plus-square"></i></a>
    </span>
</div>
